export default {
    item: {
        username: '用户名',
        password: '密码',
        email: '邮箱',
    },

    userForm: {
        title: '角色咨詢',
        id: '請輸入角色Id',
        idEmptyRemind: '角色Id不能為空',
        idErrorRemind: '角色Id必須為數字值',
        email: '請輸入電子郵箱',
        emailEmptyRemind: '請輸入郵箱地址',
        emailErrorRemind: '請輸入正確的郵箱地址',
        required: '必填：請填寫個人電子郵箱(郵箱名稱不小於4位)，接受本次訂單的收據.',
    },
    confirm: '確認',
    cancel: "取消",
    shop: {
        name: '商品',
        detail: '商品詳情',
        little0: '禮包',
        little1: '代金券',
    },
    info: '詳情',
    order: {
        summary: '訂單摘要',
        id: '角色ID',
        nikeName: '角色暱稱',
        email: '電子郵箱',
        productName: '商品名稱',
        paymentAmount: '支付金額',
        payWarn: "溫馨提示：為了縮短商品到賬延遲，支付成功後建議",
        payObvious: "重新啟動遊戲客戶端軟件",
    },
    jsHint: {
        role:{
            notExist: "查無該角色信息！！！",
            infoError: "角色信息輸入錯誤！！！",
            input: "請先輸入角色信息！！！",
        },
        shop: {
            choose: "請選擇商品！！！",
            limit: "該商品已達到購買上線，請重新選擇！！！",
        },
        order: {
            fail: "創建訂單失敗，請聯繫客服！！！" ,
        },
    },

    channel: {
        title: "支付渠道",
        EN: "英文地區",
        TW: "繁體中文地區",
        CN: "簡體中文地區",
        SCN: "簡體中文(東南亞地區)",
        warn: "請選擇所在區域便於我們提供支付方式。",
    },


}